import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import cn from "classnames";
import style from "../../common.module.scss";
import { Order } from "../../../../../services";
import OrdersInfoCargo from "../../components/OrdersInfoCargo";
import OrdersInfoHeader from "../../components/OrdersInfoHeader";
import OrdersInfoBasic from "../../components/OrdersInfoBasic";
import OrdersInfoDirections from "../../components/OrdersInfoDirections";
import Loading from "../../../../shared/Loading/Loading";
import { toast } from "react-toastify";
import SuggestPrice from "../../components/SuggestPrice";
import OrdersInfoAddressList from "../../components/OrdersInfoAddressList";
import { useParams, useNavigate } from "react-router-dom";
import CustomButton from "../../../../custom/custom-button/CustomButton";
import OrdersChatHub from "../../../../shared/chat/OrdersChatHub";
import { useLanguage } from "../../../../../context/LanguageContext";

const OrderInfoMobileMarketplace = ({ tenderOrderInfo, isAvailablePage = true }) => {
  const { t } = useTranslation();
  const { currentLanguage } = useLanguage();
  const company = useSelector((state) => state.user.company);
  const params = useParams();
  const navigate = useNavigate();
  const orderId = params.id;

  const [getOrder, setOrder] = useState(null);
  const [cargoDetails, setCargoDetails] = useState();
  const [recipient, setRecipient] = useState();
  const [unreadMessagesCount, setUnreadMessagesCount] = useState(0);

  const [isLoading, setLoading] = useState(false);
  const [isOpenModalHistory, setIsOpenModalHistory] = useState(false);
  const [isOpenChatModal, setIsOpenChatModal] = useState(false);

  const onForceUpdate = () => {
    fetchOrderData();
  };

  const fetchOrderData = async () => {
    setLoading(true);
    if (orderId) {
      try {
        const { data } = await Order.getOrderById(orderId, currentLanguage);
        if (data.shippingDate) {
          let date = data.shippingDate.split("T");
          const timeStart = data.shippingHourFrom < 10 ? `0${data.shippingHourFrom}` : data.shippingHourFrom;
          const timeEnd = data.shippingHourTo < 10 ? `0${data.shippingHourTo}` : data.shippingHourTo;
          data.shippingDate = `${date[0]}T${timeStart}:00:00`;
          data.shippingDateEnd = `${date[0]}T${timeEnd}:00:00`;
        }
        if (data.unloadingDate) {
          let date = data.unloadingDate.split("T");
          const timeStart =
            data.unloadingHourFrom < 10 ? `0${data.unloadingHourFrom}` : data.unloadingHourFrom;
          const timeEnd = data.unloadingHourTo < 10 ? `0${data.unloadingHourTo}` : data.unloadingHourTo;
          data.unloadingDate = `${date[0]}T${timeStart}:00:00`;
          data.unloadingDateEnd = `${date[0]}T${timeEnd}:00:00`;
        }
        setOrder(data);
        console.log("[DATA]", data);
      } catch (e) {
        console.log(e);
        toast.error(t("orderInfo.genericError"));
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    setUnreadMessagesCount(0);

    if (getOrder) {
      Order.getCargo(getOrder.cargoId)
        .then((response) => {
          if (response.status == 200) {
            setCargoDetails(response.data);
          } else {
            setCargoDetails({});
          }
        })
        .catch((error) => {
          console.log(error);
          toast.error(t("orderInfo.genericError"));
        });

      Order.getUnreadMessages(getOrder.id)
        .then((response) => {
          if (response.status === 200) {
            setUnreadMessagesCount(response.data?.count || 0);
          }
        })
        .catch((error) => {
          console.log(error);
        });

      Order.getRecipient(getOrder.recipientId)
        .then((response) => {
          if (response.status == 200) {
            setRecipient(response.data);
          } else {
            setRecipient({});
          }
        })
        .catch((error) => {
          console.log(error);
          toast.error(t("orderInfo.genericError"));
        });

      if (getOrder.companyId !== company.id) {
        Order.createOrderView(getOrder.id)
          .then(() => {})
          .catch((error) => {
            console.log(error);
          });
      }
    }
  }, [getOrder]);

  useEffect(() => {
    fetchOrderData();
  }, [orderId]);

  return (
    <div className={cn(style.wrapper_mobile)}>
      <OrdersInfoHeader item={getOrder} onForceUpdate={onForceUpdate} />

      {isOpenChatModal && getOrder && (
        <OrdersChatHub
          isOpen={isOpenChatModal}
          orderData={getOrder}
          orderId={getOrder.id}
          orderNumber={getOrder.number}
          onClose={() => setIsOpenChatModal(false)}
        />
      )}

      {isLoading ? <Loading borderRadius="16px" /> : null}

      {getOrder && getOrder.status !== "awaitingoffer" ? (
        <div className={style.orders_content} style={{ textAlign: "center", padding: "40px 20px" }}>
          <h3 style={{ marginBottom: "16px", fontSize: "18px", fontWeight: "600" }}>
            {t("orderInfo.tenderClosed")}
          </h3>
          <p style={{ marginBottom: "24px", color: "#666" }}>{t("orderInfo.orderNotAvailable")}</p>
          <CustomButton text={t("orderBooking.button.back")} onClick={() => navigate(-1)} isFall />
        </div>
      ) : (
        <div className={style.orders_content}>
          <OrdersInfoBasic
            item={getOrder}
            onOpen={() => setIsOpenModalHistory(true)}
            isMarketplacePage
            onOpenChat={() => setIsOpenChatModal(true)}
            unreadCount={unreadMessagesCount}
          />

          {getOrder && getOrder.addressList.length < 1 ? (
            <OrdersInfoDirections
              item={getOrder}
              senderName={getOrder?.senderName}
              recipientName={recipient?.name}
              isMarketplacePage
            />
          ) : (
            <OrdersInfoAddressList order={getOrder} addressList={getOrder?.addressList} isMarketplacePage />
          )}

          {getOrder && !getOrder.expeditorId && (
            <SuggestPrice
              onRefreshOrder={fetchOrderData}
              item={getOrder}
              cargoDetails={cargoDetails}
              onUpdateData={() => onForceUpdate()}
              tenderOrderInfo={tenderOrderInfo || []}
            />
          )}

          <OrdersInfoCargo item={cargoDetails} order={getOrder} />
          <span className={style.orders_author}>
            {/* <InfoIcon /> {getOrder?.author} {getOrder?.createdAtStr} */}
          </span>
        </div>
      )}
    </div>
  );
};

export default OrderInfoMobileMarketplace;
